import { render, staticRenderFns } from "./HelpdeskLinkedUsersTab.vue?vue&type=template&id=d8957794&scoped=true&"
import script from "./HelpdeskLinkedUsersTab.vue?vue&type=script&lang=ts&"
export * from "./HelpdeskLinkedUsersTab.vue?vue&type=script&lang=ts&"
import style0 from "./HelpdeskLinkedUsersTab.vue?vue&type=style&index=0&id=d8957794&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8957794",
  null
  
)

export default component.exports